import React from "react";

// v2-1574: the owner's selection of replays on his channel, to delete several at once. Null outside a channel's
// list of replays, so a replay preview anywhere else behaves as it always did.
export const ChanelSelectionContext = React.createContext(null);
